import { appHttpRequest } from '@/utils/AppHttpRequest';
import { IMaintenanceDetail } from './bmsBillmaintenanceType';

class MaintenanceService {
	async one(id: string) {
		const apiUrl = `/bcm/maintenance/findById/${id}`;
		return await appHttpRequest.get<IMaintenanceDetail>(apiUrl);
	}
}
export const maintenanceService = new MaintenanceService();
